/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from "react";
import { Column } from "../../../../../common/commonComponents/lotDetailsTable";
import { FinalQualityParameter, ParameterEvaluation } from "../../../types/mediaFinalQuality.types";
import { t } from "i18next";



export const getColumnsForQualityParameters = (
    evaluations: Record<string, ParameterEvaluation>,
    handleStatusChange: (id: string, pass: boolean) => void,
    handleCountChange: (id: string, count: number) => void,
    errors: Record<string, string>,
    setErrors: React.Dispatch<React.SetStateAction<Record<string, string>>>
): Column[] => [
    {
        header: t("mediaBatchInit.finalQuality.Parameter"),
        key: "parameter_name",
        className: "px-6 py-2 text-[11px]",
    },
    {
        header: t("mediaBatchInit.finalQuality.Outcome"),
        className: "px-6 py-2 text-center",
        render: (row: FinalQualityParameter) => {
            // Default to 'Pass' if not yet interacted with
            const currentEval = evaluations[row.id] || { pass_flag: true };

            return (
                <div className="flex justify-center gap-6">
                    <label className="flex items-center gap-1.5 cursor-pointer">
                        <input
                            type="radio"
                            name={`p-${row.id}`}
                            className="text-green-600 focus:ring-green-500"
                            checked={currentEval.pass_flag === true}
                            onChange={() => handleStatusChange(row.id, true)}
                        />
                        <span className="text-[10px] font-black uppercase text-green-700">
                            Pass
                        </span>
                    </label>
                    <label className="flex items-center gap-1.5 cursor-pointer">
                        <input
                            type="radio"
                            name={`p-${row.id}`}
                            className="text-red-600 focus:ring-red-500"
                            checked={currentEval.pass_flag === false}
                            onChange={() => handleStatusChange(row.id, false)}
                        />
                        <span className="text-[10px] font-black uppercase text-red-700">
                            Fail
                        </span>
                    </label>
                </div>
            );
        },
    },
    {
        header: t("mediaBatchInit.finalQuality.FailedCount"),
        className: "px-6 py-2 text-center",
        render: (row: FinalQualityParameter) => {
            const currentEval = evaluations[row.id] || { pass_flag: true };
            const isPassed = currentEval.pass_flag !== false;

            return (
                <div className="flex flex-col items-center">
                    <input
                        type="number"
                        min="0"
                        disabled={isPassed}
                        value={isPassed ? 0 : currentEval.fail_count || ""}
                        onChange={(e) => {
                            const value = parseInt(e.target.value, 10) || 0;
                            handleCountChange(row.id, value);
                            if (value > 0) {
                                setErrors(prev => ({
                                    ...prev,
                                    [row.id]: "",
                                }));
                            }
                        }}
                        className={`w-16 h-8 rounded text-xs text-center outline-none focus:ring-0 ${
                            isPassed
                                ? "border-0 bg-transparent text-gray-400 cursor-not-allowed"
                                : "border border-gray-200 focus:border-[#FF7043]"
                        }`}
                    />
                    {errors[row.id] && (<p className="mt-1 text-[11px] text-red-500">{errors[row.id]}</p>)}
                </div>
            );
        },
    },
];
